module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-tee-da2d79560c8cca6e1ee4c0163a889559.svg";